import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DocumentFlag } from '../../../core/models/DocumentFlag';
import { DocumentFlagUtils } from '../../../core/utils/DocumentFlagUtils';

@Component({
  selector: 'app-document-flag-chip',
  template: `
    <span class="badge rounded-pill document-flag-chip"
          [class.archived]="flag.archived"
          [class.large]="size === 'lg'"
          [style.background-color]="flag.colour"
          [style.color]="textColour">{{ flag.name }}</span>
  `,
  styleUrls: ['./document-flag-chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentFlagChipComponent {
  @Input({ required: true }) flag: Pick<DocumentFlag, 'name' | 'colour' | 'archived'>;
  @Input() size: 'sm' | 'lg' = 'sm';

  get textColour(): string {
    return DocumentFlagUtils.textColour(this.flag.colour);
  }
}
